'use strict';


import $ from 'jquery';
import ModalView from '../../js/components/ModalView';
import successTemplate from './templates/_ResendEmailSuccessModal.hbs';
import mediator from '../../js/mediator';
import config from '../../js/config';
import * as featureFlags from '../../utilities/featureFlags';
let instance = null;
let loginUsername, loginPassword;

export default class ResendEmailSuccessModalView extends ModalView {
  initialize() {
    super.initialize({ template: successTemplate, remodal: { closeOnOutsideClick: false } });
    this.isApacRegion = document.getElementById('region').value;
    this.greCaptchaToken = '';
    this.mtCaptchaToken = '';
    this.loginPageLoad = true;
    mediator.on(config.urls.login.reCaptchaSucess, this.reCaptchaSuccessCallback, this);
    mediator.on(config.urls.login.mtCaptchaSucess, this.mtCaptchaSuccessCallback, this);
    window.onReCaptchaSubmit = this.reCaptchaCallback;
    window.onMTCaptchaSubmit = this.mtCaptchaCallback;
  }
  initializeElements() {
    this.$firstElement = this.$('.Modal-close.Icon.Icon--cross');
    this.$lastElement = this.$('#success-button');
    this.$modalContainer = this.$('.Modal-dialog.ForgotPassword-modal');
  }
  static handleOpenerClicked(e) {
    e.preventDefault();
    ResendEmailSuccessModalView.getInstance().mtReCaptchaResendEmail();
  }
  reCaptchaCallback(token) {
    mediator.trigger(config.urls.login.reCaptchaSucess, token);
  }
  mtCaptchaCallback(state) {
    mediator.trigger(config.urls.login.mtCaptchaSucess, state.verifiedToken);
  }
  mtCaptchaSuccessCallback(token) {
    this.mtCaptchaToken = token;
    if (!this.loginPageLoad) {
      this.resendEmailClick();
    }
  }
  reCaptchaSuccessCallback(token) {
    this.greCaptchaToken = token;
    if (token !== null) {
      this.resendEmailClick();
    } else {
      $('.message-fail').css('display', 'block');
    }
  }
  mtReCaptchaResendEmail() {
    if (this.isApacRegion === 'true') {
      this.loginPageLoad = false;
      $('.mtcaptcha').css('display', 'block');
      if (featureFlags.EnableMTCaptcha.isEnabled() && (mtcaptcha && mtcaptcha.getVerifiedToken())) {
        if (!this.mtCaptchaToken) {
          this.mtCaptchaToken = mtcaptcha.getVerifiedToken();
        }
        this.resendEmailClick();
      } else if (!featureFlags.EnableMTCaptcha.isEnabled()) {
        this.resendEmailClick();
      }
    } else {
      featureFlags.EnableReCaptcha.isEnabled() && grecaptcha ? grecaptcha.execute() : this.resendEmailClick();
    }
  }
  open() {
    this.renderModal();
    super.open();
  }
  resendEmailClick() {
    const response = this.resendEmail(loginUsername, loginPassword, this.mtCaptchaToken, this.greCaptchaToken);
    response.then((data) => {
      if (data.data.success) {
        this.open();
        if (this.isApacRegion === 'false') {
          if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
            grecaptcha.reset();
          }
        } else {
          $('.mtcaptcha').css('display', 'none');
          if (featureFlags.EnableMTCaptcha.isEnabled() && mtcaptcha) {
            mtcaptcha.resetUI();
          }
        }
      } else {
        $('.message-fail').css('display', 'block');
      }
    });
  }
  resendEmail(username, password, mtCaptchaToken, greCaptchaToken) {
    let postData = {
      username: username,
      password: password,
      mtCaptchaToken: mtCaptchaToken,
      reCaptchaToken: greCaptchaToken
    };
    return $.ajax({
      type: 'POST',
      url: '/api/login/resendemail',
      data: postData,
      contentType: 'application/x-www-form-urlencoded'
    }).then((data, textStatus, request) => {
      let headerCurrentUserFirstName = request.getResponseHeader('currentUserFirstName');
      if (headerCurrentUserFirstName) {
        window.localStorage.currentUserFirstName = headerCurrentUserFirstName;
      }
      if (!featureFlags.EnableHybrisIntegration.isEnabled() || !data || !data.data || !data.data.success) {
        return data.data;
      }
      return jQueryRefreshToken().then(
        (hybrisData) => {
          if (hybrisData.access_token) {
            if (window && window.Arrow) {
              window.Arrow.isAuthorized = true;
            }
          }
          return data.data;
        },
        () => {
          // FIXME: hard code error message for now.
          // hybris error message will come from hybris server side in the future
          return $.when({
            success: false,
            showModal: false,
            modalMessage: globalisation.pluraliseAndTranslate('customerSupport', 'lockedOutMessage'),
            modalTitle: globalisation.pluraliseAndTranslate('customerSupport', 'lockedOutTitle'),
            redirectUrl: null,
            domainAuthenticationUrls: null
          });
        })
        .then((response) => {
          let d = $.Deferred();
          cartApi.mergeCart().then(
            () => {
              d.resolve(response);
            },
            () => {
              log.error('merge cart fail');
              d.resolve(response);
            });
          return d.promise();
        });
    });
  }
  modalClosing() {
    this.$modalContainer.removeAttr('aria-modal');
    super.modalClosing();
  }
  renderModal() {
    // Render main view
    if (this.isApacRegion === 'false') {
      if (featureFlags.EnableReCaptcha.isEnabled() && grecaptcha) {
        grecaptcha.reset();
      }
    } else {
      if (featureFlags.EnableMTCaptcha.isEnabled() && mtcaptcha) {
        mtcaptcha.resetUI();
        this.loginPageLoad = true;
      }
    }
    this.$el.html(this.template());
  }

  onOpen() {
    this.initializeElements();
    this.$modalContainer.attr('aria-modal', true);
    this.$modalContainer.attr('aria-describedby', 'resendEmail-success-message');
    this.$modalContainer.focus();
    this.$firstElement.attr('role', 'button');
    this.$firstElement.on('keydown', (e) => {
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastElement.focus();
      }
    });
    this.$lastElement.on('keydown', (e) => {
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstElement.focus();
      }
    });
  }

  static getInstance() {
    if (!instance) {
      instance = new ResendEmailSuccessModalView();
    }

    return instance;
  }

}
export function updatePasswordRequiredView($parent, username, password) {
  loginUsername = username;
  loginPassword = password;
  let $resendEmailLink = $parent.find('.resend-email-success-modal');
  if ($resendEmailLink.length) {
    $resendEmailLink.on('click', ResendEmailSuccessModalView.handleOpenerClicked);
  }
}



// WEBPACK FOOTER //
// ./assets/components/Login/ResendEmailSuccessModal.js